import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import vueNiceScrollbar from 'vue-nice-scrollbar'
import CKEditor from '@ckeditor/ckeditor5-vue'
import shortUUID from 'short-uuid'
import HelloJS from 'hellojs'
import VueHelloJS from 'vue-hellojs'
import VueSocialSharing from 'vue-social-sharing'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy, faBell, faComment, faHourglass, faEnvelope, faClock, faEdit, faPlusSquare, faFolder, faFolderOpen, faFile, faFileWord, faFileExcel, faFilePowerpoint, faFilePdf, faImage, faFileImage } from '@fortawesome/free-regular-svg-icons'
import { faLink, faSignOutAlt, faQuestion, faWallet, faPhoneAlt, faInfoCircle, faHandHoldingMedical, faImage as fasImage, faNewspaper, faFilm, faFileUpload, faBars, faHome, faSun, faTrashAlt, faPlus, faCross, faSignInAlt, faChurch, faHeart, faComments, faReply, faSpinner, faShare, faAngleRight, faTimesCircle, faExclamation, faChevronUp, faChevronLeft, faChevronRight, faChevronCircleRight, faChevronCircleLeft, faSave, faGlobe, faInfo, faHeadphones, faCogs } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faFacebook, faVk, faPaypal, faOdnoklassniki, faTwitter, faWhatsapp, faViber, faSkype, faTelegram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import store from '@/store'
import router from '@/router'
import { i18n } from '@/locale/i18n'

import App from '@/App'

library.add(faCopy, faLink, faQuestion, faSignOutAlt, faHourglass, faWallet, faPhoneAlt, faHandHoldingMedical, faInfoCircle, faFolder, faFolderOpen, faFile, faFileWord, faFileExcel, faFilePowerpoint, faFilePdf, faFileImage, faNewspaper, faImage, fasImage, faFilm, faFileUpload, faBell, faComment, faTimesCircle, faEnvelope, faBars, faClock, faHome, faSun, faTrashAlt, faEdit, faPlusSquare, faPlus, faCross, faSignInAlt, faChurch, faHeart, faComments, faReply, faSpinner, faShare, faAngleRight, faExclamation, faChevronUp, faChevronCircleRight, faChevronCircleLeft, faChevronLeft, faChevronRight, faSave, faGlobe, faInfo, faHeadphones, faCogs)
library.add(faFacebookSquare, faFacebook, faVk, faPaypal, faOdnoklassniki, faTwitter, faWhatsapp, faViber, faSkype, faTelegram)
Vue.component('font-awesome-icon', FontAwesomeIcon)

HelloJS.init({
  // google: 'AIzaSyASvowoVpyqjkzji5aup_LoVeac0DKiwnA',
  facebook: '223912198715660',
  vk: '7421827'
}, {
  scope: 'email',
  redirect_uri: '/welcome'
})

Vue.use(VueHelloJS, HelloJS)
Vue.use(VueSocialSharing)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(vueNiceScrollbar)
Vue.use(CKEditor)
Vue.use({
  install (v) {
    v.prototype.$busy = function () {
      this.$events.$emit('busy')
    }
    v.prototype.$idle = function () {
      this.$events.$emit('idle')
    }
  }
})
Vue.use({
  install (v) {
    // const translator = shortUUID('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ+-_=')
    const translator = shortUUID()
    v.prototype.$toUUID = function (str) {
      return translator.toUUID(str)
    }
    v.prototype.$fromUUID = function (str) {
      return translator.fromUUID(str)
    }
  }
})

Vue.config.productionTip = false
Vue.prototype.$events = new Vue()

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
Vue.directive('click-outside', {
  bind () {
    this.event = event => this.vm.$emit(this.expression, event)
    this.el.addEventListener('click', this.stopProp)
    document.body.addEventListener('click', this.event)
  },
  unbind () {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },
  stopProp (event) {
    event.stopPropagation()
  }
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
